// ======================================================================
// File Name       : email
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const EMAIL_ADD_GROUP = 'EMAIL_ADD_GROUP';
export const EMAIL_ADD_REMOVE_USER = 'EMAIL_ADD_REMOVE_USER';
export const EMAIL_ADD_REMOVE_ALL_USER = 'EMAIL_ADD_REMOVE_ALL_USER';
export const EMAIL_ADD_SELECTED_USER = 'EMAIL_ADD_SELECTED_USER';
export const EMAIL_CHECK_ALL_USER = 'EMAIL_CHECK_ALL_USER';
export const EMAIL_DEL_GROUP = 'EMAIL_DEL_GROUP';
export const EMAIL_RESET_INIT_DATA = 'EMAIL_RESET_INIT_DATA';
export const EMAIL_RESET_SEARCH_USER_DATA = 'EMAIL_RESET_SEARCH_USER_DATA';
export const EMAIL_RESET_SEARCH_USER_CONDITION = 'EMAIL_RESET_SEARCH_USER_CONDITION';
export const EMAIL_RECEIVE_STRUCTURE_LIST = 'EMAIL_RECEIVE_STRUCTURE_LIST';
export const EMAIL_RECEIVE_SEARCH_CONDITION = 'EMAIL_RECEIVE_SEARCH_CONDITION';
export const EMAIL_RECEIVE_USER_SEARCH_RESULT = 'EMAIL_RECEIVE_USER_SEARCH_RESULT';
export const EMAIL_RECEIVE_ALL_USER_SEARCH_RESULT = 'EMAIL_RECEIVE_ALL_USER_SEARCH_RESULT';
export const EMAIL_REMOVE_USER = 'EMAIL_REMOVE_USER';
export const EMAIL_REMOVE_ALL_USER = 'EMAIL_REMOVE_ALL_USER';
export const EMAIL_REMOVE_SELECTED_USER = 'EMAIL_REMOVE_SELECTED_USER';

export const GET_EMAIL_LIST = 'GET_EMAIL_LIST';
export const GET_EMAIL_DETAIL = 'GET_EMAIL_DETAIL';
export const GET_RESERVED_EMAIL_LIST = 'GET_RESERVED_EMAIL_LIST';
export const GET_RESERVED_EMAIL_DETAIL = 'GET_RESERVED_EMAIL_DETAIL';
export const GET_RESERVED_EMAIL_EDIT = 'GET_RESERVED_EMAIL_EDIT';
export const GET_USER_SECERN_ID_LIST = 'GET_USER_SECERN_ID_LIST';

export const ALL_USER_RECEIVED_BY_EMAIL = 'ALL_USER_RECEIVED_BY_EMAIL';
export const ALL_USER_ATTRIBUTE_RECEIVED = 'ALL_USER_ATTRIBUTE_RECEIVED';
export const ALL_USER_GROUP_RELATION_RECEIVED = 'ALL_USER_GROUP_RELATION_RECEIVED';
export const ALL_GROUP_RELATION_RECEIVED = 'ALL_GROUP_RELATION_RECEIVED';
export const ALL_USER_LIST_RECEIVED = 'ALL_USER_LIST_RECEIVED';
export const ADD_USER_TO_LIST_BY_EMAIL = 'ADD_USER_TO_LIST_BY_EMAIL';
export const BACKUP_INIT_STATE = 'BACKUP_INIT_STATE';
export const INSERT_TEMPLATE_DATA = 'INSERT_TEMPLATE_DATA';
export const RESTORE_INIT_STATE = 'RESTORE_INIT_STATE';
export const RECEIVE_USERS_FROM_COURSE_HISTORY = 'RECEIVE_USERS_FROM_COURSE_HISTORY';
export const SAVE_RECEIVER = 'SAVE_RECEIVER';
export const SAVE_EMAIL_RECEIVER_SAVE_KEY = 'SAVE_EMAIL_RECEIVER_SAVE_KEY';
